import { render, staticRenderFns } from "./Espaco.vue?vue&type=template&id=69fe116e&"
import script from "./Espaco.vue?vue&type=script&lang=js&"
export * from "./Espaco.vue?vue&type=script&lang=js&"
import style0 from "./Espaco.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports